var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfficialIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 2.91675H8.33073C5.18803 2.91675 3.61669 2.91675 2.64037 3.89306C1.66406 4.86937 1.66406 6.44071 1.66406 9.58341V10.4167C1.66406 13.5594 1.66406 15.1308 2.64037 16.1071C3.61669 17.0834 5.18803 17.0834 8.33073 17.0834H11.6641C14.8067 17.0834 16.3781 17.0834 17.3544 16.1071C18.3307 15.1308 18.3307 13.5594 18.3307 10.4167V9.58341C18.3307 6.44071 18.3307 4.86937 17.3544 3.89306C16.3781 2.91675 14.8067 2.91675 11.6641 2.91675Z",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16406 13.3334C5.02714 11.1825 8.2442 11.041 9.16406 13.3334",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1276 8.12508C8.1276 8.9305 7.47469 9.58341 6.66927 9.58341C5.86385 9.58341 5.21094 8.9305 5.21094 8.12508C5.21094 7.31966 5.86385 6.66675 6.66927 6.66675C7.47469 6.66675 8.1276 7.31966 8.1276 8.12508Z",
    stroke: "#00B074",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 7.08325H15.8307M11.6641 9.99992H15.8307M11.6641 12.9166H13.7474",
    stroke: "#00B074",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficialIconGreen);
export default __webpack_public_path__ + "static/media/official-icon-green.ac61a876f89e3cfc1f1adc39fd60ca9e.svg";
export { ForwardRef as ReactComponent };